import React from 'react';
import './LoveLoading.module.scss';

export const LoveLoading = () => {
  return (
    <div>
      <div className='love-loading'>
        <div className='love-icon lv-fill'/>
        <div className='love-icon lv-empty'>
          <div className='lv-empty-relative'>
            <div className='waves'/> 
          </div>
        </div>
      </div>
    </div>
  )
}
